import { createAToZArray } from 'app/utils/create-a-to-z-array'
import { BrandListItemProps } from '../components/brand-list/brand-list-item'

export type BrandGroup = {
  groupName: string
  items: BrandListItemProps[]
}

export const groupBrandsByAlphabet = (brands: BrandListItemProps[]): BrandGroup[] => {
  const alphabets = createAToZArray()
  const brandGroups: BrandGroup[] = alphabets.map((alphabet) => ({
    groupName: alphabet.toLocaleUpperCase(),
    items: [],
  }))

  //add group without any brand
  brands.map((brand) => {
    const firstLetter = brand.slug.charAt(0).toLocaleUpperCase() //group brands using slug to avoid special characters from brand names
    const groupIndex = brandGroups.findIndex((item) => item.groupName === firstLetter)
    if (groupIndex > -1) {
      brandGroups[groupIndex]?.items.push(brand)
    }
  })

  return brandGroups
}
